import { Typography } from '@mui/material';
import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { InhaltWrapper } from 'src/pages/private/online-antrag/antrag-components/Wrapper';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const BeitragZumFoerderziel: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Beitrag zum Förderziel' description={PLATZHALTER_TEXT} />
			<InhaltWrapper marginTop='0'>
				<Typography>
					Bitte stellen Sie dar, inwieweit Ihr Projektziel einen Beitrag zum Förderziel (siehe Allgemeine Hinweise → Förderziel) leistet. Bitte
					stellen Sie den unmittelbaren Bezug zu den Entwicklungspolitischen Leitlinien des Landes und SDG her.
				</Typography>
				<Typography>
					<strong>Leitfrage:</strong> Inwiefern trägt Ihr Projekt dazu bei, innerhalb der Dimensionen der Sustainable Development Goals (SDG) der
					Vereinten Nationen und der prioritären Handlungsfelder der Leitlinien zur Entwicklungszusammenarbeit der Hessischen Landesregierung das
					Leben der Menschen im Globalen Süden zu verbessern (bei Auslandsprojekten) oder Bewusstsein in Hessen für die Lebenssituation der
					Menschen im Globalen Süden zu schaffen (bei Inlandsprojekten)?
				</Typography>
			</InhaltWrapper>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default BeitragZumFoerderziel;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [{ ...P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Beitrag_Zum_Foerderziel, maxCharLength: 2500 }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucBeitragZumFoerderziel = (_application: any) => {
	return concat(formStruc());
};
